
class RandomImageService{

    imageArray:any=[
        'random.png',
        'random1.png',
        'random2.png',
        // 'random2.jpg',
        // 'random3.jpg',
        // 'random4.jpg',
        // 'random5.jpg',
        // 'random6.jpg',
        // 'random7.jpg',
        // 'random8.jpg'
    ];

    cPimageArray:any=[
        // 'randomimage (1).png',
        'randomimage (2).png',
        // 'randomimage (3).png',
        // 'randomimage (4).png',
        // 'randomimage (5).png',
        // 'randomimage (6).png',
        // 'random2.jpg',
        // 'random3.jpg',
        // 'random4.jpg',
        // 'random5.jpg',
        // 'random6.jpg',
        // 'random7.jpg',
        // 'random8.jpg'
    ];

   public randomImage () {
        return this.imageArray[Math.floor(Math.random()*this.imageArray.length)];
      }

    public randomCpImage () {
        return this.cPimageArray[Math.floor(Math.random()*this.cPimageArray.length)];
    }
  
}
export default new RandomImageService();